import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";
import markup from "ulysses/features/menu.html";
import "ko-sortable";

"use strict";
ko.bindingHandlers.menu_editor = {
    init: function(elt, va, allbindings, model, context) {
        $(elt).html(markup);
        var child_model = {
            "menu": va(),
            "selection": ko.observable(null),
            "select": function(menuitem) {

                child_model.selection(menuitem);
            },
            "add_section": function() {
                var new_section = {
                    "caption":ko.observable(_("menu_new_section", "New Section")),
                    "icon": ko.observable(null),
                    "left_icon": ko.observable(null),
                    "action": ko.observable(null),
                    "link": ko.observable(null),
                    "items": ko.observableArray([])
                };
                ko.unwrap(va()).items.push(new_section);
                child_model.selection(new_section);
            },
            "add_item": function() {
                if (child_model.selection()) {
                    var new_item = {
                        "caption":ko.observable(_("menu_new_item", "New Item")),
                        "icon": ko.observable(null),
                        "left_icon": ko.observable(null),
                        "action": ko.observable("navigateto"),
                        "link": ko.observable(null),
                    };
                    child_model.selection().items.push(new_item);
                    child_model.selection(new_item);
                }
            },
            "delete_item": function(item) {
                console.log("deleting:", item, arguments);
                var sections = ko.unwrap(va()).items;
                var section = sections.indexOf(item);
                if (section >= 0) {
                    sections.splice(section, 1);
                    child_model.selection(null);
                } else {
                    $.each(ko.unwrap(sections), function(idx, section) {
                        console.log("checking section:", idx, section);
                        var item_idx = section.items.indexOf(item);
                        if( item_idx >= 0) {
                            section.items.splice(item_idx, 1);
                            child_model.selection(section);
                            return false;
                        }
                    });
                }
            }
        };
        var child_context = context.createChildContext(child_model);
        ko.applyBindingsToDescendants(child_context, elt);
        $(elt).data("menu", child_model);
        return { "controlsDescendantBindings": true };
    },
    update: function(elt, va) {
        var menu = va();
        var menu_data = ko.unwrap(menu);
        var keys = ["icon", "left_icon", "caption", "action", "link"];
        if (menu_data.items) {
            ko.unwrap(menu_data.items).forEach(function(s) {
                keys.forEach(function(k) {
                    if (typeof s[k] == "undefined") {
                        s[k] = ko.observable(null);
                    }
                });
                if (s.items) {
                    ko.unwrap(s.items).forEach(function(ss) {
                        keys.forEach(function(k) {
                            if (typeof ss[k] == "undefined") {
                                ss[k] = ko.observable(null);
                            }
                        });
                    });
                }
            });
        }
        var child_model = $(elt).data("menu");
        ko.unwrap(child_model.selection);
    }
};
